const TWO_DIGIT_YEAR = /^\d{1,2}\D?\d{1,2}\D?\d{2}$/;

export function resolveTwoDigitYear(parsedDate: Date, typedText: string, today: Date): Date {
  if (!TWO_DIGIT_YEAR.test(typedText.trim()) || parsedDate <= today) {
    return parsedDate;
  }

  const previousCentury = new Date(parsedDate);
  previousCentury.setFullYear(parsedDate.getFullYear() - 100);

  return previousCentury;
}
